import axios from 'axios';

const stripTrailingApiSegment = (value: string) => value.replace(/\/+$/, '').replace(/\/api$/i, '');
const ensureApiBaseUrl = (value: string) => `${stripTrailingApiSegment(value)}/api`;
const GUEST_VIEW_PATHS = new Set(['/', '/content', '/open-auditions']);

const API_URL = process.env.REACT_APP_API_URL
  ? ensureApiBaseUrl(process.env.REACT_APP_API_URL)
  : 'http://localhost:5000/api';
const CHAT_API_URL = process.env.REACT_APP_CHAT_API_URL
  ? ensureApiBaseUrl(process.env.REACT_APP_CHAT_API_URL)
  : 'http://localhost:5001/api';
const REQUEST_TIMEOUT_MS = 15000;

const isProfileBootstrapRequest = (error: any) => {
  const requestUrl = String(error?.config?.url || '');
  return requestUrl === '/user/profile' || requestUrl.endsWith('/user/profile');
};

const shouldStayOnCurrentPageAfter401 = (error: any) =>
  GUEST_VIEW_PATHS.has(window.location.pathname) && isProfileBootstrapRequest(error);

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: REQUEST_TIMEOUT_MS,
});

export const chatApi = axios.create({
  baseURL: CHAT_API_URL,
  headers: { 'Content-Type': 'application/json' },
  timeout: REQUEST_TIMEOUT_MS,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

chatApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptors
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response?.status === 403 &&
      error.response?.data?.requiresProfileCompletion
    ) {
      if (window.location.pathname !== '/complete-profile') {
        window.location.replace('/complete-profile');
      }
    }
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      if (shouldStayOnCurrentPageAfter401(error)) {
        return Promise.reject(error);
      }
      const code = error.response?.data?.code;
      const nextPath =
        code === 'signed_in_elsewhere'
          ? '/login?reason=signed_in_elsewhere'
          : '/login';
      if (`${window.location.pathname}${window.location.search}` !== nextPath) {
        window.location.replace(nextPath);
      }
    }
    return Promise.reject(error);
  }
);

chatApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      const code = error.response?.data?.code;
      const nextPath =
        code === 'signed_in_elsewhere'
          ? '/login?reason=signed_in_elsewhere'
          : '/login';
      if (`${window.location.pathname}${window.location.search}` !== nextPath) {
        window.location.replace(nextPath);
      }
    }
    return Promise.reject(error);
  }
);

export default api;
